<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="产品名称" prop="name">
              <el-input
                v-model="formParameter.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品编号" prop="code"
              ><el-input
                v-model="formParameter.code"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品来源" prop="source">
              <select-option-dictionary
                v-model="formParameter.source"
                dkey="prod-source"
              ></select-option-dictionary>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="状态:" prop="state">
              <select-option-dictionary
                v-model="formParameter.state"
                dkey="spr-backlog-states"
              ></select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="PO:" prop="po">
              <el-select
                v-model="formParameter.po"
                filterable
                placeholder="可搜索选择"
              >
                <el-option
                  v-for="item in poes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总人日(天)" prop="allManDay"
              ><el-input
                type="number"
                min="0"
                v-model="formParameter.allManDay"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品价值" prop="price">
              <el-input
                type="number"
                v-model="formParameter.price"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品进度:" prop="progress">
              <el-slider v-model="formParameter.progress"></el-slider>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                v-model="formParameter.startTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime"
              ><el-date-picker
                v-model="formParameter.endTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="干系人" prop="stakeholder"
              ><el-input
                type="textarea"
                autosize
                v-model="formParameter.stakeholder"
                autocomplete="off"
                title="Scrum 团队以外、对产品感兴趣的所有人任何会受到产品影响、或者能影响产品开发结果的个人 / 群体。
范围不局限于最终使用软件的人，只要和项目、产品有利益关联都算。
常见干系人举例：
最终使用产品的用户
产品负责人（Product Owner）
公司管理层、投资人、业务方领导
销售、市场、客服团队
合规、法务、运维人员
客户方对接人（不一定亲自操作系统）"
              ></el-input
            ></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户信息" prop="customers"
              ><el-input
               title="直接使用产品、操作系统、完成业务任务的人。
关注点：产品好不好用、功能能否完成自己的工作任务。"
                type="textarea"
                autosize
                v-model="formParameter.customers"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="产品备注" prop="remarks">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 20 }"
                v-model="formParameter.remarks"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="24" v-show="prView">
          <el-button :disabled="false" @click="handleUserStroy"
            >产品故事</el-button
          >
          <el-button :disabled="false" @click="handleProductGoal"
            >产品目标</el-button
          >
          <el-button :disabled="false" @click="handleDOD">DOD</el-button>
        </el-col>
      </el-row>

      <!-- 文本类用户故事展示-->
      <el-dialog
        title="用户故事"
        :modal="false"
        :width="'1000'"
        :visible.sync="userStorydialogVisible"
      >
        <wang-edit v-model="formParameter.userStory"> </wang-edit>
        <div style="margin: auto">
          <el-button @click="userStorydialogVisible = false">关 闭</el-button>
          <el-button v-if="!disabled" type="primary" @click="updtUserStory"
            >提交更新</el-button
          >
        </div>
      </el-dialog>
      <!-- pdf类用户故事展示 -->
      <el-dialog
        title="用户故事"
        :modal="false"
        :width="'1000'"
        :visible.sync="userStorydialog2Visible"
      >
        <div v-if="disabled">
          <el-button @click="downUserStory">点击下载</el-button>
        </div>
        <div v-else>
          <drag-file-upload
            v-model="formParameter.userStory"
            model="fileSystem"
            uri="/statics/attachment"
            :size="10240"
          >
          </drag-file-upload>
          <el-button @click="uploadUserStory">点击上传</el-button>
        </div>
      </el-dialog>
      <!-- 文本类产品目标展示 -->
      <el-dialog
        title="产品目标"
        :modal="false"
        :width="'1000'"
        :visible.sync="productGoaldialogVisible"
      >
        <wang-edit v-model="formParameter.goal"> </wang-edit>
        <div style="margin: auto">
          <el-button @click="productGoaldialogVisible = false">关 闭</el-button>
          <el-button v-if="!disabled" type="primary" @click="updtProductGoal"
            >提交更新</el-button
          >
        </div>
      </el-dialog>
      <!-- pdf类产品目标展示 -->
      <el-dialog
        title="产品目标"
        :modal="false"
        :width="'1000'"
        :visible.sync="productGoaldialogVisiblepdf"
      >
        <div v-if="disabled">
          <el-button @click="downUserStory">点击下载</el-button>
        </div>
        <div v-else>
          <drag-file-upload
            v-model="formParameter.goal"
            model="fileSystem"
            uri="/statics/attachment"
            :size="10240"
          >
          </drag-file-upload>
          <el-button @click="uploadProductGoal">点击上传</el-button>
        </div>
      </el-dialog>
      <!-- 文本类产品定义展示-->
      <el-dialog
        title="产品定义"
        :modal="false"
        :width="'1000'"
        :visible.sync="DODVisible"
      >
        <wang-edit :isupdt="isUpdtWedit" v-model="formParameter.boundary">
        </wang-edit>
        <div style="margin: auto">
          <el-button @click="DODVisible = false">关 闭</el-button>
          <el-button v-if="!disabled" type="primary" @click="updtDOD"
            >提交更新</el-button
          >
        </div>
      </el-dialog>
      <!-- pdf类产品定义展示 -->
      <el-dialog
        title="产品定义"
        :modal="false"
        :width="'1000'"
        :visible.sync="DODVisiblepdf"
      >
        <div v-if="disabled">
          <el-button @click="downDOD">点击下载</el-button>
        </div>
        <div v-else>
          <drag-file-upload
            v-model="formParameter.boundary"
            model="fileSystem"
            uri="/statics/attachment"
            :size="10240"
          >
          </drag-file-upload>
          <el-button @click="uploadDOD">点击上传</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >确 定</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/product/product/product.js";
import apiAtta from "@/api/attachment/attachment/attachment.js";
import userApi from "@/api/system/user/user.js";

import wangEdit from "@/components/wangEdit/wangEditLess.vue";

import dragFileUpload from "@/components/biz/fileUpload/dragFileUpload.vue";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import showProductGoal from "@/views/product/productBoard/showProductGoal.vue";
import PDF from "vue-pdf";
import productBoardApi from "@/api/product/productBoard/productBoard.js";

export default {
  name: "edit",
  components: {
    popup,
    wangEdit,
    selectOptionDictionary,
    dragFileUpload,
    showProductGoal,
    productBoardApi,
    PDF,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},

      userStorydialogVisible: false,
      userStorydialog2Visible: false,
      productGoaldialogVisible: false, //产品目标页面
      productGoaldialogVisiblepdf: false, //产品目标页面是否为pdf
      DODVisible: false, //dod页面
      DODVisiblepdf: false, //dod的pdf页面
      prView: true, //三个按钮显示

      isUpdtWedit: false, //用于更新wangEdit

      poes: [],

      rules: {
        //产品名称
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 50,
            trigger: "blur",
          },
        ],
        //产品编号
        code: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: "blur",
          },
        ],
        //产品来源
        source: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 30,
            trigger: "blur",
          },
        ],
        //状态
        state: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 10,
            trigger: "blur",
          },
        ],
        //产品负责人
        po: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //总人日天数
        allManDay: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 8,
            trigger: "blur",
          },
        ],
        //产品价值
        price: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 10,
            trigger: "blur",
          },
        ],
        //项目开始时间
        startTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //项目结束时间
        endTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //干系人
        stakeholder: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //用户（客户）信息
        customers: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 200,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //提交表单
    uploadUserStory() {
      //判断一下文件是否大于0，否则不提交
      if (this.formParameter.userStory <= 0) {
        this.$message.error("必须上传附件哦！");
        return;
      }
      let path = this.formParameter.userStory.substr(
        this.formParameter.userStory.indexOf("/statics")
      );
      let params = {};
      console.log("path ", path);
      console.log("this.formParameter.id ", this.formParameter.id);
      //添加, 将文件也进行手动提交
      params.name = "用户故事-" + this.formParameter.name;
      params.type = "userStroy";
      params.path = path;
      params.productId = this.formParameter.id;

      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        apiAtta.saveUpload2(
          params,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    handleUserStroy() {
      //伪代码： 判断是不是附件，是附件  show ：下载   ，edit：上传，不是附件， show ：v-html显示，edit: wangEdit编辑
      if (
        this.formParameter.userStory &&
        this.formParameter.userStory.length > 20
      ) {
        if (this.formParameter.userStory.substr(0, 8) == "/statics") {
          //是附件
          this.userStorydialog2Visible = true;
        } else {
          this.userStorydialogVisible = true;
        }
      } else {
        // 默认是文本
        this.userStorydialogVisible = true;
      }
    },
    updtUserStory() {
      api.update(
        { id: this.formParameter.id, userStory: this.formParameter.userStory, userStory: "修改用户故事" },
        (res) => {
          this.userStorydialogVisible = false;
          // this.saveToTrends(this.formParameter.name, "用户故事", this.formParameter.id);
          this.$utils.msg.success("更新【用户故事】成功");
        },
        (err) => {
          this.$utils.msg.warning(err.msg);
        }
      );
    },
    downUserStory() {},
    //提交更新产品目标
    uploadProductGoal() {
      //判断一下文件是否大于0，否则不提交
      if (this.formParameter.goal <= 0) {
        this.$message.error("必须上传附件哦！");
        return;
      }
      let path = this.formParameter.goal.substr(
        this.formParameter.goal.indexOf("/statics")
      );
      let params = {};
      console.log("path ", path);
      console.log("this.formParameter.id ", this.formParameter.id);
      //添加, 将文件也进行手动提交
      params.name = "产品目标-" + this.formParameter.name;
      params.type = "checkStandard";
      params.path = path;
      params.productId = this.formParameter.id;

      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        apiAtta.saveUpload2(
          params,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    //查看产品目标
    handleProductGoal() {
      console.log(this.formParameter.id);
      //伪代码： 判断是不是附件，是附件  show ：下载   ，edit：上传，不是附件， show ：v-html显示，edit: wangEdit编辑
      if (this.formParameter.goal && this.formParameter.goal.length > 20) {
        if (this.formParameter.goal.substr(0, 8) == "/statics") {
          //是附件
          this.productGoaldialogVisiblepdf = true;
        } else {
          this.productGoaldialogVisible = true;
        }
      } else {
        // 默认是文本
        this.productGoaldialogVisible = true;
      }
    },
    //更新产品目标
    updtProductGoal() {
      api.update(
        { id: this.formParameter.id, goal: this.formParameter.goal, userStory: "修改产品目标" },
        (res) => {
          this.productGoaldialogVisible = false;
          // this.saveToTrends(this.formParameter.name, "产品目标", this.formParameter.id);
          this.$utils.msg.success("更新【产品目标】成功");
        },
        (err) => {
          this.$utils.msg.warning(err.msg);
        }
      );
    },
    //下载产品目标
    downDOD() {},
    //上传提交更新dod
    uploadDOD() {
      //判断一下文件是否大于0，否则不提交
      if (this.formParameter.boundary <= 0) {
        this.$message.error("必须上传附件哦！");
        return;
      }
      let path = this.formParameter.boundary.substr(
        this.formParameter.boundary.indexOf("/statics")
      );
      let params = {};
      console.log("path ", path);
      console.log("this.formParameter.id ", this.formParameter.id);
      //添加, 将文件也进行手动提交
      params.name = "产品定义-" + this.formParameter.name;
      params.type = "boundarySetting";
      params.path = path;
      params.productId = this.formParameter.id;

      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        apiAtta.saveUpload2(
          params,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    //预览dod
    handleDOD() {
      //伪代码： 判断是不是附件，是附件  show ：下载   ，edit：上传，不是附件， show ：v-html显示，edit: wangEdit编辑
      if (
        this.formParameter.boundary &&
        this.formParameter.boundary.length > 20
      ) {
        if (this.formParameter.boundary.substr(0, 8) == "/statics") {
          //是附件
          this.DODVisiblepdf = true;
        } else {
          this.DODVisible = true;
        }
      } else {
        // 默认是文本
        this.DODVisible = true;
      }
    },
    //更新产品定义DOD文本
    updtDOD() {
      api.update(
        { id: this.formParameter.id, boundary: this.formParameter.boundary, userStory: "修改DOD" },
        (res) => {
          this.DODVisible = false;
          // this.saveToTrends(this.formParameter.name, "产品定义", this.formParameter.id);
          this.$utils.msg.success("更新【产品定义】成功");
        },
        (err) => {
          this.$utils.msg.warning(err.msg);
        }
      );
    },
    //将操作保存到动态中
    saveToTrends(productName, problem, pid) {
      //将操作添加到动态
      let userData = this.$caches.user.get();
      let nowTime = new Date();
      let trendsData = {
        userId: userData.id,
        operate: "修改了" + productName + "的",
        problemSolving: problem,
        startTime: nowTime,
        pid: pid
      };
      productBoardApi.saveTrends(trendsData, (response) => {
        console.log(response.data);
      });
    },

    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      if (!this.parameter.id) {
        //添加产品列表
        this.prView = false;
      } else {
        this.prView = true;
      }

       if(  this.formParameter.boundary ){
          this.isUpdtWedit = true
          setTimeout(()=>{
            this.isUpdtWedit = false
          },100)
        }

      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      //发送请求，将当前的name发送给后端进行查重

      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          api.distinct(
            { name: this.formParameter.name, code: this.formParameter.code },
            (res) => {
              if (res.data) {
                //查出来的数据不是空的，则提醒不能够重复
                this.$message.error({
                  message: "产品名称和编号不能够重复哦！",
                });
                this.confirmLoading = false;
                return;
              } else {
                let parameter = this.$utils.merger(this.formParameter);
                api.save(
                  parameter,
                  (response) => {
                    this.$utils.msg.success(response.msg);
                    this.confirmLoading = false;
                    this.close();
                    this.$parent.list();
                  },
                  (response) => {
                    this.$utils.msg.warning(response.msg);
                    this.confirmLoading = false;
                  }
                );
              }
            }
          );
          //添加
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      //查询所有用户，选择po
      userApi.listAll({}, (response) => {
        this.poes = response.data;
      });

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
